module.exports = __webpack_public_path__ + "static/all-1_PLACEHOLDER-d32caf70ea3d1961ff7f1cbaab944c32.png";